var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.valid)?_c('h3',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.error_message))]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid),expression:"valid"}],staticClass:"stream-video"})])}
var staticRenderFns = []

export { render, staticRenderFns }